import React from "react";

export const SectionTitle = ({ eyebrow, title, subtitle, align = "center", light = false }) => {
  const alignCls = align === "left" ? "text-left items-start" : "text-center items-center";
  const colors = light ? "text-ivory" : "text-emerald";
  const subColor = light ? "text-ivory/75" : "text-charcoal-muted";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl ${align === "center" ? "mx-auto" : ""} mb-12 reveal`}>
      {eyebrow && (
        <span className="text-[11px] uppercase tracking-[0.32em] text-gold mb-3">{eyebrow}</span>
      )}
      <h2 className={`font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight ${colors}`}>{title}</h2>
      {subtitle && <p className={`mt-5 text-base md:text-lg leading-relaxed ${subColor}`}>{subtitle}</p>}
    </div>
  );
};

export default SectionTitle;
